import React, { useContext, useEffect, useRef, useState } from "react";
import { ERROR_MESSAGES } from "../../../components/common/GlobalMassssage";
import Select from "react-select";

import SuccessModal from "../../../components/common/SuccessModal";
import { AuthContext, LoaderContext } from "../../../Context/ContextFunctions";

import { AddUpdateKRA, GetKRAModel } from "../../../services/KRA/KRAapi";
import { GetRoleTypeLookupList } from "../../../services/UserRole/UserRoleApi";

const AddUpdateKRAModal = ({
  isOpen,
  onClose,
  setIsAddUpdateDone,
  modelRequestData,
}) => {
  const inputRef = useRef(null);
  const ModuleName = "Predefined";
  const [kraName, setKRAName] = useState("");
  const [requireErrorMessage, setRequireErrorMessage] = useState(false);
  const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [modelAction, setModelAction] = useState("");
  const [roleTypeKeyID, setroleTypeKeyID] = useState("");
  const { authDetails } = useContext(AuthContext);
  const { setLoader } = useContext(LoaderContext);
  const [roleTypeoptions, setcustomerIndustryOptions] = useState([]);
  useEffect(() => {
    if (isOpen) {
      inputRef.current?.focus();
      GetRoleTypeLookupListData();
    }
  }, [isOpen]);

  const GetRoleTypeLookupListData = async () => {
    try {
      const adminKeyID = authDetails?.adminKeyID;
      if (!adminKeyID) return;

      let response = await GetRoleTypeLookupList(ModuleName, adminKeyID);

      console.log("API Response:", response); // Debugging step

      // Check if response contains data
      if (response?.statusCode === 200) {
        const roleTypeOption = response?.responseData?.data.map((val) => ({
          value: val.roleTypeKeyID,
          label: val.roleName,
        }));
        console.log("Mapped Options:", roleTypeOption); // Confirm correct mapping

        setcustomerIndustryOptions(roleTypeOption);
      } else {
        console.warn("Unexpected API response structure", response);
      }
    } catch (error) {
      console.error("Error fetching market lookup list:", error);
    }
  };

  //getModel
  useEffect(() => {
    setModelAction(modelRequestData?.Action === null ? "Add" : "Update"); // Use optional chaining
    if (
      modelRequestData?.KeyID !== undefined &&
      modelRequestData?.KeyID !== null &&
      modelRequestData?.Action === "Update"
    ) {
      GetUserRoleModelData(modelRequestData.KeyID);
    } else {
      setKRAName("");
    }
    setErrorMessage("");
  }, [modelRequestData]);
  if (!isOpen) return null;

  //Get Model
  const GetUserRoleModelData = async (KeyID) => {
    setLoader(true);
    const data = await GetKRAModel(ModuleName, KeyID, authDetails.adminKeyID);
    if (data.statusCode === 200) {
      setLoader(false);
      const ModalData = data.responseData.data;
      setKRAName(ModalData.kraName);
      setroleTypeKeyID(ModalData.roleTypeKeyID); // Set the roleTypeKeyID from the response
    } else {
      setLoader(false);
    }
  };
  const handleRoleType = async () => {
    if (
      kraName === undefined ||
      kraName === null ||
      kraName === "" ||
      roleTypeKeyID === undefined ||
      roleTypeKeyID === null ||
      roleTypeKeyID === ""
    ) {
      setRequireErrorMessage(true);
      return false;
    }
    setLoader(true);
    try {
      const data = await AddUpdateKRA({
        adminKeyID: authDetails.adminKeyID,
        kraName: kraName,
        kraKeyID: modelRequestData.KeyID,
        ModuleName: ModuleName,
        roleTypeKeyID: roleTypeKeyID,
      });
      if (data?.statusCode === 200) {
        setLoader(false);
        setIsAddUpdateDone(true);
        // onClose(); // Close the StaffRoleModal
        setShowSuccessPopupModal(true); // Show the SuccessModal
      } else {
        setLoader(false);
        const errorMessage = data?.response?.data?.errorMessage;
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  return (
    <>
      <div
        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
        onClick={onClose}
        aria-hidden={!isOpen}
      >
        <div
          className="bg-white rounded-lg shadow-lg w-full max-w-md"
          role="dialog"
          aria-modal="true"
          onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
        >
          {/* Modal Header */}
          <div className="bg-[#ECF6FF] px-6 py-4 border-b flex justify-between items-center">
            <h2 className="text-16 font-semibold">{modelAction} KRA</h2>
            <button
              className="text-gray-500 hover:text-gray-700"
              onClick={onClose}
              aria-label="Close Modal"
            >
              ✕
            </button>
          </div>

          {/* Modal Body */}
          <div className="p-6 grid grid-cols-1 gap-2">
            {" "}
            {/* Change gap-4 to gap-0 */}
            {/* Customer Industry Select */}
            <div className="mb-0 w-full">
              {" "}
              {/* Change mb-4 to mb-0 */}
              <label className="block text-12 text-gray-700 mb-1">
                User Role <span style={{ color: "red" }}>*</span>
              </label>
              <Select
                options={roleTypeoptions}
                className="w-full text-12"
                placeholder="Select User Role"
                value={roleTypeoptions.find(
                  (option) => option.value === roleTypeKeyID
                )}
                onChange={(selectedOption) => {
                  setroleTypeKeyID(selectedOption ? selectedOption.value : "");
                }}
              />
              {requireErrorMessage &&
              (roleTypeKeyID === "" ||
                roleTypeKeyID === undefined ||
                roleTypeKeyID === null) ? (
                <label className="validation">{ERROR_MESSAGES}</label>
              ) : (
                ""
              )}
            </div>
            {/*Designation Name  Input */}
            <div className="mb-0 w-full">
              {" "}
              {/* Change mb-4 to mb-0 */}
              <label className="block text-12 text-gray-700 mb-1">
                KRA <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                maxLength={150}
                className="w-full p-2 border rounded-md text-12"
                placeholder="Enter KRA"
                value={kraName}
                onChange={(e) => {
                  let value = e.target.value;

                  // Capitalize the first letter if the input is not empty
                  if (value.length > 0) {
                    value = value.charAt(0).toUpperCase() + value.slice(1);
                  }

                  // Allow only letters at the start, then letters & spaces after the first character
                  if (/^[A-Za-z][A-Za-z\s]*$/.test(value) || value === "") {
                    setKRAName(value);
                  }
                }}
              />
              {requireErrorMessage &&
              (kraName === "" || kraName === undefined || kraName === null) ? (
                <label className="validation">{ERROR_MESSAGES}</label>
              ) : (
                ""
              )}
            </div>
          </div>

          {errorMessage && (
            <div className="text-center mb-2">
              <label className="validation ">{errorMessage}</label>
            </div>
          )}

          {/* Modal Footer */}
          <div className="bg-gray-100 px-6 py-4 border-t flex justify-end gap-3">
            <button
              type="button"
              className="px-4 py-2 bg-gray-300 rounded-md text-12"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              onClick={() => handleRoleType()}
              className="px-4 py-2 text-white bg-[#E86B1B] rounded-md text-12"
            >
              Submit
            </button>
          </div>
        </div>

        <SuccessModal
          isOpen={showSuccessPopupModal}
          onClose={() => {
            onClose();
            setShowSuccessPopupModal(false);
          }}
          modelAction={modelAction}
          actionMessage={kraName}
        />
      </div>
    </>
  );
};

export default AddUpdateKRAModal;
